import { useEffect } from 'react';
import type { ReactNode } from 'react';

import {
  registerResourceOpener,
  ResourceOpenerProvider
} from '@setvi/shared/providers/resource-opener';

import { useOpenResource } from './hooks/use-open-resource';

interface ResourcePreviewProviderProps {
  children: ReactNode;
}

/**
 * Makes `useResourceOpener()` print-order aware for everything underneath.
 * Must sit inside `DialogProvider` (the preview opens as a dialog).
 */
export const ResourcePreviewProvider = ({
  children
}: ResourcePreviewProviderProps) => {
  const openResource = useOpenResource();

  // Also register globally: dialogs are rendered outside this subtree (see
  // registerResourceOpener), so the context alone would not reach them.
  useEffect(() => {
    registerResourceOpener(openResource);
    return () => registerResourceOpener(null);
  }, [openResource]);

  return (
    <ResourceOpenerProvider openResource={openResource}>
      {children}
    </ResourceOpenerProvider>
  );
};
